import { ExploreNfts } from 'modules/nft/containers';

export const Mixed = () => {
  return <ExploreNfts variant="Mixed" />;
};
